import { render, staticRenderFns } from "./GoodsCate.vue?vue&type=template&id=67e0f5c7&scoped=true"
import script from "./GoodsCate.vue?vue&type=script&lang=js"
export * from "./GoodsCate.vue?vue&type=script&lang=js"
import style0 from "./GoodsCate.vue?vue&type=style&index=0&id=67e0f5c7&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e0f5c7",
  null
  
)

export default component.exports